import React, { useState } from "react";
import { Space, Select, DatePicker, Input } from "antd";


const CargoActivationFilters = ({ filters, onFiltersChange }) => {
  const [searchField, setSearchField] = useState("userEmail");

  const searchBy = (
    <Select
      defaultValue="userEmail"
      className="select-before"
      onChange={(value) => setSearchField(value)}
      >
        <Select.Option value="userEmail">User Email</Select.Option>
    </Select>
  );

  return (
    <Space size="large" wrap>
      <div>
        Search :{` `}
        <Input.Search
          addonBefore={searchBy}
          placeholder="Search"
          onSearch={(term) => onFiltersChange({ ...filters, search: term, searchField})}
        />
      </div>

      <div>
        <DatePicker.RangePicker
          value={[filters.startDate, filters.endDate]}
          onChange={(dates) =>
            dates
              ? onFiltersChange({
                  ...filters,
                  startDate: dates[0],
                  endDate: dates[1],
                })
              : onFiltersChange({
                  ...filters,
                  startDate: undefined,
                  endDate: undefined,
                })
          }
        />
      </div>

      <div>
        Status :{` `}
        <Select
          placeholder="ALL"
          style={{ width: 120 }}
          allowClear
          onChange={(value) =>
            onFiltersChange({ ...filters, status: value })
          }
        >
          <Select.Option value={'PENDING'}>Pending</Select.Option>
          <Select.Option value={'APPROVED'}>Approved</Select.Option>
          <Select.Option value={'REJECTED'}>Rejected</Select.Option>
        </Select>
      </div>
    </Space>
  );
};

export default CargoActivationFilters;
